export interface GrapesCmsContent {
  type: 'grapesjs'
  html: string
  css: string
  project?: Record<string, unknown>
}

export interface ParsedCmsContent {
  type: 'grapesjs' | 'html'
  html: string
  css: string
  project?: Record<string, unknown>
  raw: string
}

export function parseCmsContent(content?: string | null): ParsedCmsContent {
  const raw = content?.trim() || ''

  if (!raw) {
    return { type: 'html', html: '', css: '', raw: '' }
  }

  if (raw.startsWith('{')) {
    try {
      const parsed = JSON.parse(raw) as Partial<GrapesCmsContent>
      if (parsed.type === 'grapesjs') {
        return {
          type: 'grapesjs',
          html: parsed.html || '',
          css: parsed.css || '',
          project: parsed.project,
          raw,
        }
      }
    } catch {
      // Fall through to legacy HTML handling.
    }
  }

  return { type: 'html', html: raw, css: '', raw }
}

export function serializeGrapesContent(
  html: string,
  css: string,
  project: Record<string, unknown>,
): string {
  const payload: GrapesCmsContent = {
    type: 'grapesjs',
    html,
    css,
    project,
  }
  return JSON.stringify(payload)
}

/**
 * Scope GrapesJS CSS to the CMS render root so `body`/`*` rules don't leak
 * site-wide, and keep large/fixed-width blocks inside the viewport on mobile.
 */
export function scopeCmsCss(css: string, scope = '.cms-rendered-content'): string {
  const trimmed = css.trim()
  if (!trimmed) return ''

  // Grapes often targets body/html — remap those to the render root.
  const remapped = trimmed
    .replace(/(^|[{},;\s])body\b/g, `$1${scope}`)
    .replace(/(^|[{},;\s])html\b/g, `$1${scope}`)

  return `@scope (${scope}) {
${remapped}
}

@media (max-width: 767px) {
  ${scope},
  ${scope} :where(*) {
    max-width: 100% !important;
    box-sizing: border-box;
  }

  ${scope} :where(img, video, iframe, embed, object, svg) {
    height: auto !important;
  }
}`
}

